import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 5,
    marginBottom: 5,
  },
  sub: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
  },
  billTo: {
    color: "#000",
    fontSize: 10,
    textAlign: "left",
    marginTop: 10,
    marginBottom: 10,
    lineHeight: 1.5,
  },
});

const Subject = ({ invoice }) => (
  <View style={styles.headerContainer}>
    <Text style={styles.sub}><b>Sub: Quotation for your travel Itinerary</b></Text>
    <Text style={styles.billTo}>
      {" "}
      Dear Sir/Madam, {"\n"}
      Please find below the details of the prices for the travel items as per
      your requirements.{" "}
    </Text>
  </View>
);

export default Subject;
